export const mainMixin = {
    data() {
        return {
            
        }
    },
    methods: {
        scrollTo(element, scrollPixels, duration) {
            const scrollPos = element.scrollLeft;
    
            // Condition to check if scrolling is required
            if ( !( (scrollPos === 0 || scrollPixels > 0) && (element.clientWidth + scrollPos === element.scrollWidth || scrollPixels < 0))) 
            {
                // Get the start timestamp
                const startTime =
                "now" in window.performance
                    ? performance.now()
                    : new Date().getTime();
                
                const scroll = (timestamp) => {
                //Calculate the timeelapsed
                const timeElapsed = timestamp - startTime;
                //Calculate progress 
                const progress = Math.min(timeElapsed / duration, 1);
                //Set the scrolleft
                element.scrollLeft = scrollPos + scrollPixels * progress;
                //Check if elapsed time is less then duration then call the requestAnimation, otherwise exit
                if (timeElapsed < duration) {
                    //Request for animation
                    window.requestAnimationFrame(scroll);
                } else {
                    return;
                }
                }
                //Call requestAnimationFrame on scroll function first time
                window.requestAnimationFrame(scroll);
            }
        },
        parseTimezone(dates){
          console.log('Datetime confirm order..', (dates).toLocaleString())
          let localeOffset = new Date().getTimezoneOffset()
          console.log('locale offset',localeOffset)
          let malaysiaTimeZoneOffset = -480;
          let diffZoneOffset = (malaysiaTimeZoneOffset - localeOffset)/60
          let utc = (dates).getTime()
          let timeZoneForMalaysia = new Date(utc+(3600000*diffZoneOffset))
          console.log('local date object', timeZoneForMalaysia)
          console.log('local timzone', timeZoneForMalaysia.toLocaleString())
          
          return timeZoneForMalaysia
        },

    }
};